/**
 * `errorCode` del 409 de api-admin (reenviado tal cual por api) cuando el carrito mix trae
 * `controlNumbers` con la solicitud gratuita activa (ADM-827): un carrito desfasado. Se muestra
 * como aviso, nunca como rechazo de pago, y se recarga el estado de la solicitud.
 */
export const CONTROL_NUMBERS_FREE_MODE = 'CONTROL_NUMBERS_FREE_MODE';

/** Copy del 409 `CONTROL_NUMBERS_FREE_MODE` (api-admin), solo como respaldo si el body no lo trae. */
export const CONTROL_NUMBERS_FREE_MODE_TITLE = 'Solicitud gratuita activa';
export const CONTROL_NUMBERS_FREE_MODE_MESSAGE = 'Los números de control se solicitan gratis en Mejora tu Fina.';

/** El código va en la raíz del body (`err.error.errorCode`), no dentro de `data`. */
export function isControlNumbersFreeModeError(err: any): boolean {
    return err?.status === 409 && err?.error?.errorCode === CONTROL_NUMBERS_FREE_MODE;
}
